const DECIMAL2 = ($Glb, Vue) => {
    // 将数值num保留2位小数
	$Glb.decimal2 = (num) =>{
        var f = parseFloat(num); 
        if (isNaN(f)) { 
         return false; 
        } 
        var f = Math.round(num*100)/100; 
        var s = f.toString(); 
        var rs = s.indexOf('.'); 
        if (rs < 0) { 
         rs = s.length; 
         s += '.'; 
        } 
        while (s.length <= rs + 2) { 
         s += '0'; 
        } 
        return s; 
	}

}
export default DECIMAL2







// WEBPACK FOOTER //
// ./src/plugins/glb_decimal2/index.js